const validator = new RegExp(/^[\w-.+]+@([\w-]+\.)+[\w-]{2,4}$/);
export function isValidEmail(email) {
    return validator.test(email);
}
